import { collection, query, where, getDocs } from 'firebase/firestore';
import { firestore } from '../../../lib/firebase/config';
import { COLLECTIONS } from '../constants';

export const checkGuideBan = async (guideId: string, pilgrimId: string): Promise<boolean> => {
  try {
    // تحقق من الحظر في جدول GuideBans
    const bansRef = collection(firestore, COLLECTIONS.GUIDE_BANS);
    const q = query(
      bansRef, 
      where('guideId', '==', guideId),
      where('pilgrimId', '==', pilgrimId)
    );
    
    const snapshot = await getDocs(q);
    
    // تحقق من الحظر في جدول Bans
    const generalBansRef = collection(firestore, 'Bans');
    const now = Date.now();
    
    const generalBansQuery = query(
      generalBansRef,
      where('userId', '==', guideId),
      where('isActive', '==', true)
    );
    
    const generalBansSnapshot = await getDocs(generalBansQuery);
    
    // تحقق من وجود حظر نشط في جدول Bans
    const hasActiveBan = generalBansSnapshot.docs.some(doc => {
      const ban = doc.data();
      const isExpired = ban.expiresAt !== null && ban.expiresAt < now;
      return !isExpired && (ban.banType === 'linking' || ban.banType === 'full');
    });

    // إرجاع true إذا كان هناك حظر في أي من الجدولين
    return !snapshot.empty || hasActiveBan;
  } catch (error) {
    console.error('Error checking guide ban:', error);
    throw new Error('فشل في التحقق من حالة الحظر');
  }
};
